import axios from "axios";
import { useState } from "react";
import { RemoveCircleOutline } from "@material-ui/icons";
import { RemovedAssignSubject } from "../../../Api/api";

import { useAuth } from "../../../Auth/Auth";
import ConfirmationModal from "../../Modal/v2/ConfirmationModal";
import { AssignedSubject } from "../TeacherProfile.style";

export default function Subject({ staffId, subject, removeSubject }) {
  const { readCookie, DisplaySnackbar } = useAuth();
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const remove = () => {
    if (loading) return;
    setLoading(true);
    setModal(false);
    axios
      .delete(
        RemovedAssignSubject.removeAssignSubject(
          staffId,
          subject.sectionId,
          subject._id
        ),
        {
          headers: {
            token: `${readCookie("token")}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status === "succcess") {
          removeSubject(`${subject.grade}-${subject.section}`, subject._id);
          DisplaySnackbar("Deleted Assign Subject", "success");
        }
      })
      .catch((err) => {
        if (err.response) DisplaySnackbar(err.response.data.message, "error");
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <AssignedSubject
        style={{ opacity: loading ? "0.4" : "" }}
        onClick={() => {
          if (loading) return;
          setModal(true);
        }}
      >
        {subject.subject} <RemoveCircleOutline style={{ fontSize: "0.8rem" }} />
      </AssignedSubject>
      <ConfirmationModal
        key={`modal_${subject._id}`}
        open={modal}
        closeModal={() => {
          if (loading) return;
          setModal(false);
        }}
        submit={remove}
        heading={"Remove Assigned Subject"}
        message={
          <>
            You are about to remove teacher from{" "}
            <b>{`${subject?.grade}-${subject?.section}`}</b> subject{" "}
            <b>{subject?.subject}</b>.
          </>
        }
      />
    </>
  );
}
